<template>
  <div
    class="mobilePage a-uno fixed inset-0 h-full max-h-[100dvh] w-full overflow-hidden"
    :class="{ ios: os.isPhone }"
  >
    <div
      class="pageA relative isolate flex h-full w-full flex-col overflow-hidden bg-[#130706]"
    >
      <img
        class="sceneBg pointer-events-none absolute inset-0 z-0 h-full w-full object-cover"
        src="@/assets/images/landing-a/mobile-bg.webp"
        alt=""
      />
      <div
        class="header relative z-10 h-[calc(47px_+_env(safe-area-inset-top))] shrink-0 bg-[rgba(24,9,6,0.57)]"
      >
        <div
          class="brand absolute left-[7px] top-[calc(9px_+_env(safe-area-inset-top))] h-[29.7px] w-[99px]"
        >
          <img
            class="absolute left-[-0.2211914px] top-[-9px] h-[47px] w-[99.2211914px] max-w-none"
            src="@/assets/images/landing-a/mobile-brand.webp"
            alt="黄果免费看"
          />
          <img
            class="absolute left-0 top-[0.707px] h-[28.286px] w-[28.286px]"
            src="@/assets/images/landing-a/brand-icon.webp"
            alt=""
          />
        </div>
        <div
          class="contactBox absolute right-[10.5px] top-[calc(15px_+_env(safe-area-inset-top))] flex items-center gap-[4px]"
        >
          <img
            v-if="swUrl"
            class="contactItem block h-[19px] w-[66.5px] cursor-pointer"
            src="@/assets/images/landing-a/mobile-contact-sw.webp"
            alt="商务合作"
            @click="toPage(swUrl)"
          />
          <img
            v-if="tgUrl"
            class="contactItem block h-[19px] w-[66.5px] cursor-pointer"
            src="@/assets/images/landing-a/mobile-contact-tg.webp"
            alt="官方群组"
            @click="toPage(tgUrl)"
          />
          <img
            v-if="qdUrl"
            class="contactItem block h-[19px] w-[66.5px] cursor-pointer"
            src="@/assets/images/landing-a/mobile-contact-qd.webp"
            alt="渠道合作"
            @click="toPage(qdUrl)"
          />
        </div>
      </div>
      <div class="scene relative min-h-0 flex-1">
        <img
          class="sceneCharacter pointer-events-none absolute inset-x-0 top-[4.6px] z-1 mx-auto h-[min(419.524px,68%)] w-auto max-w-[74.077%] object-contain"
          src="@/assets/images/landing-a/mobile-character-placeholder.webp"
          alt=""
        />
        <img
          class="sceneTitle pointer-events-none absolute inset-x-0 bottom-[-10px] z-3 h-auto max-h-full w-full object-contain object-bottom"
          src="@/assets/images/landing-a/mobile-title.webp"
          alt="夜深了，心动才刚刚开始"
        />
      </div>
      <div
        class="downloadBox relative z-4 flex h-[clamp(44px,12dvh,68px)] shrink-0 items-start justify-center gap-[13px]"
      >
        <div
          v-if="os.isPhone"
          class="downBtn relative h-[32.181px] w-[107.27px] cursor-pointer"
          @click.stop="getApkInfo('ios', $event)"
        >
          <img
            class="pointer-events-none absolute left-[-3.4209px] top-[-1.5085px] h-[39.0229px] w-[114.1118px] max-w-none"
            src="@/assets/images/landing-a/mobile-btn-ios.webp"
            alt="苹果下载"
          />
        </div>
        <template v-else>
          <div
            class="downBtn relative h-[32.181px] w-[107.27px] cursor-pointer"
            @click.stop="getApkInfo('android', $event)"
          >
            <img
              class="pointer-events-none absolute left-[-3.4209px] top-[-1.5085px] h-[39.0229px] w-[114.1118px] max-w-none"
              src="@/assets/images/landing-a/mobile-btn-android.webp"
              alt="安卓下载"
            />
          </div>
          <div
            v-if="switchData.androidDownUrl && switchData.channelApkAndDownUrl"
            class="downBtn relative h-[32.181px] w-[107.27px] cursor-pointer"
            @click.stop="getApkInfo('androidSpare', $event)"
          >
            <img
              class="pointer-events-none absolute left-[-3.4209px] top-[-1.5085px] h-[39.0229px] w-[114.1118px] max-w-none"
              src="@/assets/images/landing-a/mobile-btn-spare.webp"
              alt="备用下载"
            />
          </div>
        </template>
      </div>
      <div
        class="footerTip relative z-5 box-border flex h-[calc(36px_+_env(safe-area-inset-bottom))] shrink-0 flex-col items-center justify-center bg-[rgba(27,0,46,0.26)] pb-[env(safe-area-inset-bottom)] text-center text-[10px] font-semibold leading-[14px] text-white"
      >
        <p class="m-0">
          提示：本APP属于特殊行业，偶尔会误报毒提醒，如有报毒提示，
        </p>
        <p class="m-0">请点击忽略，并开启飞行模式安装即可！</p>
      </div>
    </div>

    <!-- 安卓提示框 -->
    <van-overlay :show="androidPromptShow" z-index="999" class="androidOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="androidPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <!-- 苹果提示框 -->
    <van-overlay :show="iosPromptShow" z-index="999" class="iosOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="iosPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">
        请使用Safari浏览器进行下载
      </div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import { landingPageClick } from "@/utils/eventTracker";

export default {
  props: ["os", "configs", "switchData", "version"],
  data() {
    return {
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      autoDownloadTriggered: false,
      currUrl: window.location.href,
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: ""
    };
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
        return newValue;
      });
    },
    switchData: {
      immediate: true,
      handler() {
        this.tryAutoDownload();
      }
    }
  },
  mounted() {
    if (!this.checkIsSafari() && this.os.isPhone) {
      this.showTip = true;
    }
    const referrer = sessionStorage.getItem("referrer");
    const dc = sessionStorage.getItem("dc");
    if (referrer && dc) {
      this.currUrl = referrer + "user.html?dc=" + dc;
    } else {
      if (referrer) {
        this.currUrl = referrer + "user.html";
      } else {
        this.currUrl = window.location.href;
      }
    }
    // 预加载安装教程弹窗背景（藏在 display:none 的 overlay 里不会自动拉取），
    // 防止弹出时正赶上下载跳转被中断
    new Image().src = require("@/assets/images/mobile1/iosTip.webp");
    new Image().src = require("@/assets/images/mobile1/android_tip.png");
  },
  methods: {
    // 剪贴板
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          this.showTip = false;
        },
        () => {}
      );
    },
    checkIsSafari() {
      let ua = this.os.userAgent.toLowerCase();
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1
      );
    },
    // 下载数据就绪后，按当前系统自动触发一次下载
    tryAutoDownload() {
      if (this.autoDownloadTriggered) return;
      const data = this.switchData || {};
      const isIos = this.os.isPhone;
      // 安卓仅在渠道包地址存在时才自动下载
      const downUrl = isIos ? data.iosDownUrl : data.channelApkAndDownUrl;
      if (!downUrl) return;
      // iOS 非 Safari 浏览器无法下载，已弹 Safari 提示，不自动触发
      if (isIos && !this.checkIsSafari()) return;
      this.autoDownloadTriggered = true;
      this.fireWhenPageLoaded(() => {
        // 下载立即触发，安装教程弹窗延迟 5s 再弹出
        this.getApkInfo(isIos ? "ios" : "android", null, 5000);
      });
    },
    // 等页面资源加载完成再执行，避免下载跳转把加载中的图片全部中断
    fireWhenPageLoaded(fn) {
      if (document.readyState === "complete") {
        fn();
        return;
      }
      let fired = false;
      const fire = () => {
        if (fired) return;
        fired = true;
        window.removeEventListener("load", fire);
        fn();
      };
      window.addEventListener("load", fire);
      // 兜底：弱网下资源迟迟加载不完也要触发下载
      setTimeout(fire, 10000);
    },
    async showInstallTutorial(type) {
      if (type == "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async getApkInfo(type, event, tutorialDelay = 0) {
      this.$toast("应用正在下载中，十秒后无反应请再次点击下载！");
      if (tutorialDelay) {
        setTimeout(() => {
          this.showInstallTutorial(type);
        }, tutorialDelay);
      } else {
        await this.showInstallTutorial(type);
      }
      this.$emit("recordClick", type);
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      // 上报点击（下载按钮）；自动触发时无点击事件，不上报
      if (!event) return;
      let click_coordinates_x = event.clientX;
      let click_coordinates_y = event.clientY;
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x,
        click_coordinates_y
      });
    },
    toPage(path) {
      window.open(path);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.mobilePage {
  -webkit-overflow-scrolling: touch;
  font-family: -apple-system, "PingFang SC", "Helvetica Neue", "Microsoft YaHei",
    sans-serif;

  .androidOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/android_tip.png")
        no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }

  .iosOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/iosTip.webp") no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;
      position: relative;

      .appName {
        font-size: 10px;
        font-weight: 500;
        color: #242423;
        position: absolute;
        left: 79px;
        bottom: 102px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .desc {
        font-size: 7px;
        font-weight: 500;
        color: #8f908f;
        position: absolute;
        left: 79px;
        bottom: 92px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }
}

.downTip {
  border-radius: 10px;
  padding: 18px;
  box-sizing: border-box;
  text-align: center;

  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }

  .downTipContent {
    white-space: nowrap;
    font-size: 15px;
  }

  .url {
    font-size: 15px;
    margin-top: 16px;
    text-align: left;
  }

  .downTipConfirm {
    font-size: 15px;
    width: 160px;
    height: 30px;
    border-radius: 40px;
    margin: 32px auto 0;
    color: #fff;
    background: #5b92ee;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
